export default "__VITE_ASSET__6fdxOaRm__"